import React from 'react';

import ErrorBoundary from '@app/error/ErrorBoundary';

import StoreProvider from '@app/providers/QAU.StoreProvider';
import ContextProvider from '@app/providers/QAU.ContextProvider';
import LocalizationProvider from '@app/providers/QAU.LocalizationProvider';

import ArtworkInfoPopup from '@components/popups/artwork-info/ArtworkInfoPopup';
import WarningPopup from '@components/popups/warning/WarningPopup';
import ErrorPopup from '@components/popups/error/ErrorPopup';
import ViewsContainer from '@components/views/ViewsContainer';
import HelpContainer from '@components/help/HelpContainer';
import Spinner from '@components/spinner/Spinner';
import Header from '@components/header/Header';
import Footer from '@components/footer/Footer';

const QAU = () => (
  <ErrorBoundary>
    <StoreProvider>
      <ContextProvider>
        <LocalizationProvider>
          <Spinner />
          <Header />
          <ErrorPopup />
          <WarningPopup />
          <ArtworkInfoPopup />
          <HelpContainer />
          <ViewsContainer />
          <Footer />
        </LocalizationProvider>
      </ContextProvider>
    </StoreProvider>
  </ErrorBoundary>
);

export default QAU;
